<template>
  <div class="layout">
    <div class="main row" style="margin-right: 0px;">
      <div class="col" style="padding-right: 0px; padding-left: 0px;">
        <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <router-view v-show="!isLoading"></router-view>
      </div>
    </div>
    <div class="made-by-footer">
      &copy;2018&ndash;{{currentYear}}. All rights reserved by&nbsp;<a :href="companyUrl" target="_blank">{{companyName}} </a>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ThemeService from '../../services/ThemeService'

  export default {
    name: 'EmptyLayout',
    data () {
      return {
        currentTheme: 'fractel'
      }
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ]),
      currentYear () {
        var now = new Date()
        return now.getFullYear()
      },
      logoClass () {
        return `${this.currentTheme}-logo`
      },
      companyName () {
        return this.currentTheme === 'fonestorm' ? ThemeService.themes.fonestorm.company : ThemeService.themes.fractel.company
      },
      companyUrl () {
        return this.currentTheme === 'fonestorm' ? ThemeService.themes.fonestorm.companyUrl : ThemeService.themes.fractel.companyUrl
      }
    },
    mounted () {
      this.currentTheme = ThemeService.currentTheme
      // Listen for theme changes
      this.$root.$on('theme-changed', this.updateTheme)
    },
    beforeDestroy () {
      this.$root.$off('theme-changed', this.updateTheme)
    },
    methods: {
      updateTheme () {
        this.currentTheme = ThemeService.currentTheme
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';
  @import '~bootstrap/scss/mixins/breakpoints';
  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';
  .auth-layout {
    height: 100vh;
    margin: 0;
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      height: $top-mobile-nav-height;
      background-color: $top-nav-bg;
      .i-vuestic {
        height: $auth-mobile-nav-ivuestic-h;
        width: 100%;
      }
    }
    .main {
      margin: 0;
      height: 100%;
      .auth-content {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
      .auth-wallpaper {
        background-color: $top-nav-bg;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .i-vuestic {
          z-index: 2;
          height: $auth-wallpaper-ivuestic-h;
          width: 100%;
        }
        .oblique {
          position: absolute;
          background-color: $auth-wallpaper-oblique-line;
          left: calc(50% - 27%/2);
          transform: rotate(15deg);
          width: 27%;
          height: 115%;
        }
        .fractel-logo, .fonestorm-logo {
          height: 300px;
          width: 300px;
        }
      }
    }

    @include media-breakpoint-down(md) {
      .main {
        height: $auth-mobile-main-h;
        .auth-content {
          align-items: flex-start;
          padding-top: $auth-content-padding-t;
        }
      }
    }
  }

  .made-by-footer {
    position: absolute;
    padding-bottom: $made-by-footer-pb;
    height: $widget-mb;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EmptyLayout.vue